import { observable, action, computed, configure, runInAction } from "mobx";
import { createContext } from "react";
import { toast } from "react-toastify";
import agent from "../api/agent";
import { ITimeSheet } from "../models/timesheet";

configure({ enforceActions: "always" });

class EmployeeTimeSheetStore {
  @observable employeetimesheetallRegistry = new Map();
  @observable employeetimesheetRegistry = new Map();
  @observable employeetimesheet: ITimeSheet | null = null;
  @observable payrunstatusRegistry = new Map();
  @observable payrollcycleRegistry = new Map();
  @observable projecttimeRegistry = new Map();
  @observable loadingInitial = false;
  @observable submitting = false;
  @observable target = "";
  @observable inputError = false;

  @computed get employeetimesheetsByDate() {
    return Array.from(this.employeetimesheetRegistry.values()).sort(
      (a, b) => Date.parse(a.attendanceDate) - Date.parse(b.attendanceDate)
    );
  }

  @computed get payrunstatusByDate() {
    return Array.from(this.payrunstatusRegistry.values()).sort(
      (a, b) => a.financeYear - b.financeYear || a.payRun.localeCompare(b.payRun)
    );
  }

  @computed get payrollcyclesByName() {
    return Array.from(this.payrollcycleRegistry.values()).sort(
      (a, b) =>
        a.startYear.localeCompare(b.startYear) ||
        a.endYear.localeCompare(b.endYear) ||
        a.payRun.localeCompare(b.payRun)
    );
  }

  @action loadPayrollCycles = async () => {
    this.loadingInitial = true;
    try {
      const payrollcycles = await agent.PayrollCycles.list();
      runInAction("loading payroll cycles", () => {
        payrollcycles.forEach((payrollcycle) => {
          this.payrollcycleRegistry.set(
              payrollcycle.endYear +
              "-" +
              payrollcycle.payRun,
            payrollcycle
          );
        });
      });
    } catch (error) {
      runInAction("load payroll cycles error", () => {
        this.loadingInitial = false;
      });
      toast.error("load payroll cycles error");
    }
  };

  @action loadProjectTimes = async () => {
    this.loadingInitial = true;
    try {
      const projecttimes = await agent.ProjectTimes.list();
      runInAction('loading projecttimes', () => {
        projecttimes.forEach(projecttime => {
          this.projecttimeRegistry.set(projecttime.code, projecttime);
        });
        this.loadingInitial = false;
      })
    } catch (error) {
      runInAction('load Project Time List error' ,() => {
        this.loadingInitial = false;
      })
      toast.error('load Project Time List error');
    }
  };

  @action loadEmployeeTimeSheets = async () => {
    let initialPayrun = '';
    try {
      const timesheets = await agent.EmployeeTimeSheets.list();
      runInAction("loading time sheets", () => {
        this.employeetimesheetallRegistry.clear();
        timesheets.forEach((timesheet) => {
          timesheet.attendanceDate = timesheet.attendanceDate.substr(0, 10);
          this.employeetimesheetallRegistry.set(timesheet.id, timesheet);
          this.payrunstatusRegistry.set(timesheet.financeYear+timesheet.payRun, timesheet);
        });
        this.loadingInitial = false;
      });
      const sortPayrun = Array.from(this.payrunstatusRegistry.values()).sort(
        (b, a) => a.financeYear - b.financeYear || a.payRun.localeCompare(b.payRun));
      initialPayrun = sortPayrun[0].financeYear + '-' + sortPayrun[0].payRun;
    } catch (error) {
      runInAction("load time sheets Error", () => {
        this.loadingInitial = false;
      });
      toast.error("load time sheets Error");
    }
    return initialPayrun;
  };

  @action editEmployeeTimeSheets = async (employeeTimeSheets: ITimeSheet[], status: string) => {
    this.submitting = true;
    for (let i = 0; i < employeeTimeSheets.length; i ++)
    {
      if (employeeTimeSheets[i].attendant === 'Y' && employeeTimeSheets[i].projectType === '')
      {
        toast.error("Input error, please check if project is selected");
        this.submitting = false;
        this.inputError = true;
        return;
      }
      employeeTimeSheets[i].status = status;
    };
    try {
      await agent.EmployeeTimeSheets.update(employeeTimeSheets);
      runInAction("editing employee time sheet", () => {
        employeeTimeSheets.forEach((timesheet) => {
          timesheet.status = status;
          this.employeetimesheetallRegistry.set(timesheet.id, timesheet);
          this.payrunstatusRegistry.set(timesheet.financeYear+timesheet.payRun, timesheet);
        });
        this.submitting = false;
        this.inputError = false;
        toast.success('Time sheet '+ status.toLowerCase() + ' successfully!');
      });
    } catch (error) {
      runInAction("edit employee error", () => {
        this.submitting = false;
        this.inputError = false;
      });
      toast.error("edit employee error");
      console.log(error);
    }
  };

  @action selectPayRun = async (payRunFinance: string) => {
    const year = payRunFinance.split('-')[0];
    const payRun = payRunFinance.split('-')[1];
    let timeSheets = Array.from(this.employeetimesheetallRegistry.values());
    const selectedTimeSheets = timeSheets.filter((timeSheet) =>
      timeSheet.payRun === payRun && timeSheet.financeYear === year
    ).sort(
      (a, b) => Date.parse(a.attendanceDate) - Date.parse(b.attendanceDate)
    );
    this.employeetimesheetRegistry.clear();
    selectedTimeSheets.forEach((timeSheet) => {
        this.employeetimesheetRegistry.set(timeSheet.id, timeSheet);
    });
    return selectedTimeSheets;
  };

}

export default createContext(new EmployeeTimeSheetStore());
